<template>
    <v-dialog v-model="cardAdesao" max-width="800px" persistent>
        <v-card class="rounded-xl" elevation="12">
            <!-- Cabeçalho com gradiente -->
            <v-card-title class="white--text pa-6 gradient-header">
                <v-icon large left color="white">mdi-barcode-scan</v-icon>
                <span class="headline font-weight-bold">Código de Adesão</span>
                <v-spacer />
            </v-card-title>

            <v-card-text class="pa-6">
                <loading v-if="isLoading" />

                <v-container fluid class="pa-0">
                    <!-- Seção de Informações do Estudante -->
                    <v-row dense class="mb-2">
                        <v-col cols="12">
                            <div class="text-subtitle-1 font-weight-medium primary--text mb-3 d-flex align-center">
                                <v-icon small color="primary" class="mr-2">mdi-account-circle</v-icon>
                                Informações do Estudante
                            </div>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="estudante.nome" label="Nome" outlined dense disabled
                                prepend-inner-icon="mdi-account" class="disabled-field rounded-lg" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="estudante.bi" label="Nº Documento" outlined dense disabled
                                prepend-inner-icon="mdi-card-account-details" class="disabled-field rounded-lg" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="estudante.idMatricula" label="Matrícula" outlined dense disabled
                                prepend-inner-icon="mdi-identifier" class="disabled-field rounded-lg" />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="estudante.curso" label="Curso" outlined dense disabled
                                prepend-inner-icon="mdi-book-open" class="disabled-field rounded-lg" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="estudante.turma" label="Turma" outlined dense disabled
                                prepend-inner-icon="mdi-account-group" class="disabled-field rounded-lg" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="localEstudante.code" label="Código de Adesão" outlined dense disabled
                                prepend-inner-icon="mdi-lock" class="disabled-field code-field rounded-lg" />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4" />

                    <!-- Seção de Detalhes do Código -->
                    <v-row dense class="mb-2">
                        <v-col cols="12">
                            <div class="text-subtitle-1 font-weight-medium primary--text mb-3 d-flex align-center">
                                <v-icon small color="primary" class="mr-2">mdi-information</v-icon>
                                Detalhes do Código
                            </div>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="estadoCodigo" label="Estado" outlined dense disabled
                                prepend-inner-icon="mdi-state-machine" class="disabled-field rounded-lg" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="localEstudante.created_by" label="Gerado por" outlined dense disabled
                                prepend-inner-icon="mdi-account-cog" class="disabled-field rounded-lg" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="localEstudante.createdAt" label="Gerado em" outlined dense disabled
                                prepend-inner-icon="mdi-calendar-clock" class="disabled-field rounded-lg" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <!-- Rodapé com botões -->
            <v-card-actions class="pa-4">
                <v-spacer />
                <v-btn color="grey darken-1" text @click="fecharCardEditar(false)" class="px-6 rounded-pill" large>
                    <v-icon left>mdi-close</v-icon>
                    Fechar
                </v-btn>
                <v-btn color="primary" dark depressed @click="geraraCodigoAdesao" class="px-6 rounded-pill" large>
                    <v-icon left>mdi-refresh</v-icon>
                    Gerar Novo Código
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from '../../../../plugins/axios'
import axiosIMS from '../../../../plugins/axiosIMS'
import Swal from 'sweetalert2';
const ls = require('local-storage')

export default {
    props: {
        estudante: Object
    },
    components: {
        loading: () => import("../../../../components/loading.vue")
    },
    data() {
        return {
            cardAdesao: true,
            localEstudante: {
                nome: "",
                bi: "",
                dataemissaobi: "",
                datanascimento: "",
                nomedopai: "",
                nomedamae: "",
                email: "",
                telefone: "",
                matricula: "",
            },
            isLoading: false,
            estadoCodigo: "Sem código"
        };
    },

    async created() {
        await this.carregarCodAdesao();
    },

    computed: {
        Instituicao() {
            return ls.get("i_id");
        },
        nomeUsuario() {
            return ls.get("nomeUsuario");
        },
    },

    methods: {
        async carregarCodAdesao() {
            this.isLoading = true;
            try {
                let response;
                if (window.location.hostname == 'localhost') {
                    response = await axios.get(`/getCode/${this.estudante.idMatricula}`);
                } else {
                    response = await axiosIMS.get(`/getCode/${this.estudante.idMatricula}`);
                }

                if (response.data.length) {
                    this.localEstudante = response.data[0];
                    this.estadoCodigo = this.localEstudante.status == 1 ? 'Activo' : this.localEstudante.status == 0 ? 'Já usado' : 'Desabilitado';
                }

                if (this.localEstudante.status == 1) {
                    this.$emit('cancel', false);
                    Swal.fire({
                        title: 'Código de Adesão',
                        html: `
                            <div style="text-align: center;">
                                <div style="background: #f5f5f5; padding: 15px; border-radius: 12px; margin-bottom: 20px; border: 1px dashed #1976d2;">
                                    <p style="font-size: 24px; color: #1976d2; margin: 10px 0; font-family: monospace; letter-spacing: 2px;">${response.data[0].code}</p>
                                </div>
                                <p style="font-size: 14px; color: #666;">Forneça o código ao estudante.</p>
                            </div>
                        `,
                        confirmButtonText: 'Fechar',
                        width: 450,
                        customClass: {
                            container: 'swal-container',
                            popup: 'swal-popup',
                            header: 'swal-header',
                            title: 'swal-title',
                            content: 'swal-content',
                            actions: 'swal-actions',
                            confirmButton: 'swal-confirm'
                        }
                    });
                }
            } catch (error) {
                Swal.fire('Error', '<p>Erro ao carregar os dados do estudante.</p>', 'error')
            } finally {
                this.isLoading = false;
            }
        },

        fecharCardEditar(bool) {
            this.localEstudante = {
                nome: "",
                bi: "",
                dataemissaobi: "",
                datanascimento: "",
                nomedopai: "",
                nomedamae: "",
                email: "",
                telefone: ""
            };
            this.cardEditar = false;
            this.provinciaSelected = null;
            this.municipioSelected = null;
            this.$emit('cancel', bool)
        },

        async geraraCodigoAdesao() {
            try {
                let params = {
                    autor: this.nomeUsuario,
                    instituicao: this.Instituicao,
                    matricula: this.estudante.idMatricula
                }

                let result;

                if (window.location.hostname == 'localhost') {
                    result = await axios.post('/gerarCodAdesao', params).then(res => res);
                } else {
                    result = await axiosIMS.post('/gerarCodAdesao', params).then(res => res);
                }

                if (result.status == 200 && result.data.length) {
                    Swal.fire({
                        title: 'Código de Adesão',
                        html: `
                            <div style="text-align: center;">
                                <div style="background: #f5f5f5; padding: 15px; border-radius: 12px; margin-bottom: 20px; border: 1px dashed #1976d2;">
                                    <p style="margin: 0; font-weight: bold; color: #333;">Novo código:</p>
                                    <p style="font-size: 24px; color: #1976d2; margin: 10px 0; font-family: monospace; letter-spacing: 2px;">${result.data[0][0].generated_code}</p>
                                </div>
                                <p style="font-size: 14px; color: #666;">Forneça o código ao estudante.</p>
                            </div>
                        `,
                        icon: 'success',
                        confirmButtonText: 'Fechar',
                        width: 450,
                        customClass: {
                            container: 'swal-container',
                            popup: 'swal-popup',
                            header: 'swal-header',
                            title: 'swal-title',
                            content: 'swal-content',
                            actions: 'swal-actions',
                            confirmButton: 'swal-confirm'
                        }
                    });
                    this.$emit('cancel', false);
                } else {
                    Swal.fire('Informação', 'Erro ao gerar o código de adesão. Contacte o suporte técnico', 'error')
                }
            } catch (error) {
                Swal.fire('Informação', 'Erro ao gerar o código de adesão. Contacte o suporte técnico', 'error')
            }
        }
    }
};
</script>

<style scoped>
/* Estilo para campos desabilitados */
.disabled-field {
    background-color: #f8f9fa;
}

/* Estilo especial para o campo do código */
.code-field {
    font-weight: bold;
    color: #1976d2;
    letter-spacing: 1px;
}

/* Estilo do cabeçalho com gradiente */
.gradient-header {
    background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%) !important;
}

/* Estilo para os títulos das seções */
.section-title {
    border-left: 4px solid #1976d2;
    padding-left: 12px;
}

/* Cantos arredondados para os cards */
.v-card {
    overflow: hidden;
}

/* Espaçamento interno consistente */
.v-card-text {
    padding: 24px;
}

/* Estilo para os botões */
.v-btn {
    text-transform: none;
    letter-spacing: normal;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Efeito hover para os botões */
.v-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
}

/* Estilo para os ícones nos campos */
.v-input__prepend-inner i {
    color: rgba(0, 0, 0, 0.6);
}
</style>